import styles from "./index.module.scss";
import { useEffect, useState, useRef } from "react";
import bgImage from "./bg.jpg";
import {
  Tabs,
  Form,
  Input,
  Checkbox,
  Button,
  Spin,
  Modal,
  message,
} from "antd";
import { useEventListener } from "ahooks";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import Api from "../../api/index.js";
import WechatPhoneBindModal from "../../components/WechatPhoneBindModal";
import {
  resetPasswordFunction,
  phoneLoginFunction,
  redirectFunction,
  passwordLoginFunction,
} from "./loginUtilsFunc.js";
import logo from "./logo.png";
import logo2 from "./aiLogo.png";
import { setSuperGroup, setToken, getToken } from "../../utils/cookie.js";
import { getLocationOrigin } from "../../utils/util.js";
import {
  WECHAT_QR_EXPIRED_CODE,
  createQrPoller,
  getApiPayload,
} from "../../utils/wechatQr.js";
import useUrlState from '@ahooksjs/use-url-state'

const ResetPasswordForm = (props) => {
  const { onFinish, getCaptchaFunc, resetPasswordFunction } = props;
  const [form] = Form.useForm();
  const [countdownSecond, setCountdownSecond] = useState(60);
  const timer = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    if (loading) {
      return;
    }
    form
      .validateFields()
      .then(async (values) => {
        setLoading(true);
        const res = await resetPasswordFunction(values);
        if (res.success) {
          message.success("重置成功");
          onFinish();
        } else {
          message.error(res.msg);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const setCountdownSecondTimer = () => {
    if (timer.current) {
      clearInterval(timer.current);
      timer.current = null;
    }
    timer.current = setInterval(() => {
      const countdownSecond = localStorage.getItem(
        "resetPasswordCountdownSecond",
      );
      const _countdownSecond = Number(countdownSecond) - 1;

      if (_countdownSecond <= 0) {
        clearInterval(timer.current);
        timer.current = null;
        localStorage.removeItem("resetPasswordCountdownSecond");
        setCountdownSecond(60);
      } else {
        setCountdownSecond(_countdownSecond);
        localStorage.setItem("resetPasswordCountdownSecond", _countdownSecond);
      }
    }, 1000);
  };

  useEffect(() => {
    const countdownSecond = localStorage.getItem(
      "resetPasswordCountdownSecond",
    );
    if (countdownSecond) {
      setCountdownSecond(Number(countdownSecond));
      setCountdownSecondTimer();
    }
    return () => {
      if (timer.current) {
        clearInterval(timer.current);
        timer.current = null;
      }
    };
  }, []);

  const handleGetCaptcha = () => {
    form
      .validateFields(["phone"])
      .then((res) => {
        const { phone } = res;
        getCaptchaFunc(phone, "retrieve_password");
        setCountdownSecond(60);
        localStorage.setItem("resetPasswordCountdownSecond", 60);
        setCountdownSecondTimer();
      })
      .catch((error) => {
      });
  };

  return (
    <Form
      name="resetPasswordForm"
      autoComplete="off"
      className="resetPasswordForm"
      form={form}
    >
      <Form.Item
        label="手机号"
        name="phone"
        rules={[
          { required: true, message: "请输入手机号" },
          {
            pattern:
              /^(13\d|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18\d|19[0-35-9])\d{8}$/,
            message: "手机号格式不对",
          },
        ]}
      >
        <Input
          allowClear
          prefix={
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-phone-icon lucide-phone"
            >
              <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
            </svg>
          }
          className="loginFormInput"
          placeholder="请输入手机号"
          type='tel'
          autocomplete="tel"
        />
      </Form.Item>
      <Form.Item
        label="验证码"
        name="captcha"
        rules={[
          { required: true, message: "请输入验证码" },
          { pattern: /^[0-9]\d{5}$/, message: "验证码格式不对" },
        ]}
      >
        <Input
          allowClear
          prefix={
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-key-round-icon lucide-key-round"
            >
              <path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z" />
              <circle cx="16.5" cy="7.5" r=".5" fill="currentColor" />
            </svg>
          }
          className="loginFormInput"
          placeholder="请输入验证码"
          suffix={
            countdownSecond < 60 ? (
              <div className="loginFormInputCaptchaBtn">
                {countdownSecond}s后重试
              </div>
            ) : (
              <div
                className="loginFormInputCaptchaBtn"
                onClick={handleGetCaptcha}
              >
                获取验证码
              </div>
            )
          }
        />
      </Form.Item>
      <Form.Item
        label="新密码"
        name="password"
        rules={[{ required: true, message: "新密码不能为空" },
          ({ getFieldValue }) => ({
          validator(_, value) {
            if (!value) {
              return Promise.resolve()
            }
            if (value?.length < 8 || value?.length > 16) {
              return Promise.reject(
                new Error('8-16位，至少包含数字/字母/字符两种组合')
              )
            }
            let reg =
              /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[\u4E00-\u9FA5].*$)^\S{8,16}$/;
            if (!reg.test(value)) {
              return Promise.reject(
                new Error('8-16位，至少包含数字/字母/字符两种组合')
              )
            }
            return Promise.resolve()
          },
        }),]}
      >
        <Input
          allowClear
          prefix={<LockOutlined />}
          className="loginFormInput"
          placeholder="请输入密码"
          autoComplete="new-password"
        />
      </Form.Item>
      <button
        type="submit"
        className="loginFormSubmitBtn"
        onClick={handleSubmit}
      >
        重置密码
      </button>
    </Form>
  );
};

const PasswordFrom = (props) => {
  const { onFinish, getCaptchaFunc, resetPasswordFunction } = props;
  const [form] = Form.useForm();
  const [isAutoLogin, setIsAutoLogin] = useState(false);
  const [resetPasswordOpen, setResetPasswordOpen] = useState(false);

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        if (isAutoLogin) {
          const _values = values;
          localStorage.setItem("AutoLoginUserInfo", JSON.stringify(_values));
        } else {
          localStorage.removeItem("AutoLoginUserInfo");
        }
        onFinish(values);
      })
      .catch((error) => {
      });
  };

  useEffect(() => {
    const AutoLoginUserInfo = localStorage.getItem("AutoLoginUserInfo");
    if (AutoLoginUserInfo) {
      setIsAutoLogin(true);
      form.setFieldsValue(JSON.parse(AutoLoginUserInfo));
    }
  }, []);

  const resetPasswordSuccess = (values) => {
    setResetPasswordOpen(false);
  };

  return (
    <>
      <Form
        name="accountForm"
        initialValues={{
          remember: true,
        }}
        autoComplete="off"
        className="accountForm"
        form={form}
      >
        <Form.Item
          label={null}
          name="username"
          rules={[
            {
              required: true,
              message: "请输入账号",
            },
          ]}
        >
          <Input
            allowClear
            prefix={<UserOutlined />}
            className="loginFormInput"
            placeholder="请输入账号"
          />
        </Form.Item>
        <Form.Item
          label={null}
          name="password"
          rules={[
            {
              required: true,
              message: "请输入密码",
            },
          ]}
        >
          <Input.Password
            allowClear
            prefix={<LockOutlined />}
            className="loginFormInput"
            placeholder="请输入密码"
          />
        </Form.Item>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Checkbox
            checked={isAutoLogin}
            onChange={() => setIsAutoLogin(!isAutoLogin)}
          >
            自动登录
          </Checkbox>
          <Button
            type="link"
            style={{fontSize: '14px', padding: 0}}
            onClick={() => {
              setResetPasswordOpen(true);
            }}
          >
            忘记密码?
          </Button>
        </div>
        <button
          type="submit"
          className="loginFormSubmitBtn"
          onClick={handleSubmit}
        >
          登录
        </button>
      </Form>

      <Modal
        title="重置密码"
        wrapClassName="aiLoginResetPasswordModal"
        open={resetPasswordOpen}
        centered
        onCancel={() => setResetPasswordOpen(false)}
        footer={null}
        destroyOnClose={true}
      >
        <ResetPasswordForm
          resetPasswordFunction={resetPasswordFunction}
          onFinish={resetPasswordSuccess}
          getCaptchaFunc={getCaptchaFunc}
        ></ResetPasswordForm>
      </Modal>
    </>
  );
};

const PhoneForm = (props) => {
  const { onFinish, getCaptchaFunc } = props;
  const [form] = Form.useForm();
  const [countdownSecond, setCountdownSecond] = useState(60);
  const timer = useRef(null);

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        onFinish(values);
      })
      .catch((error) => {
      });
  };

  const setCountdownSecondTimer = () => {
    if (timer.current) {
      clearInterval(timer.current);
      timer.current = null;
    }
    timer.current = setInterval(() => {
      const countdownSecond = localStorage.getItem("countdownSecond");
      const _countdownSecond = Number(countdownSecond) - 1;

      if (_countdownSecond <= 0) {
        clearInterval(timer.current);
        timer.current = null;
        localStorage.removeItem("countdownSecond");
        setCountdownSecond(60);
      } else {
        setCountdownSecond(_countdownSecond);
        localStorage.setItem("countdownSecond", _countdownSecond);
      }
    }, 1000);
  };

  useEffect(() => {
    const countdownSecond = localStorage.getItem("countdownSecond");
    if (countdownSecond) {
      setCountdownSecond(Number(countdownSecond));
      setCountdownSecondTimer();
    }
    return () => {
      if (timer.current) {
        clearInterval(timer.current);
        timer.current = null;
      }
    };
  }, []);

  const handleGetCaptcha = () => {
    form
      .validateFields(["phone"])
      .then((res) => {
        const { phone } = res;
        getCaptchaFunc(phone, 2);
        setCountdownSecond(60);
        localStorage.setItem("countdownSecond", 60);
        setCountdownSecondTimer();
      })
      .catch((error) => {
      });
  };

  return (
    <Form name="phoneForm" autoComplete="off" className="phoneForm" form={form}>
      <Form.Item
        label={null}
        name="phone"
        rules={[
          {
            required: true,
            message: "请输入手机号",
          },
          {
            pattern:
              /^(13\d|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18\d|19[0-35-9])\d{8}$/,
            message: "手机号格式不对",
          },
        ]}
      >
        <Input
          allowClear
          prefix={
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-phone-icon lucide-phone"
            >
              <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
            </svg>
          }
          className="loginFormInput"
          placeholder="请输入手机号"
          type='tel'
          autocomplete="tel"
        />
      </Form.Item>
      <Form.Item
        label={null}
        name="captcha"
        rules={[
          {
            required: true,
            message: "请输入验证码",
          },
          { pattern: /^[0-9]\d{5}$/, message: "验证码格式不对" },
        ]}
      >
        <Input
          allowClear
          prefix={
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-key-round-icon lucide-key-round"
            >
              <path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z" />
              <circle cx="16.5" cy="7.5" r=".5" fill="currentColor" />
            </svg>
          }
          className="loginFormInput"
          placeholder="请输入验证码"
          suffix={
            countdownSecond < 60 ? (
              <div className="loginFormInputCaptchaBtn">
                {countdownSecond}s后重试
              </div>
            ) : (
              <div
                className="loginFormInputCaptchaBtn"
                onClick={handleGetCaptcha}
              >
                获取验证码
              </div>
            )
          }
        />
      </Form.Item>

      <button
        type="submit"
        className="loginFormSubmitBtn"
        onClick={handleSubmit}
      >
        登录
      </button>
    </Form>
  );
};

const QrFrom = (props) => {
  const { getQrFunc, onFinish, onPhoneBinding } = props;
  const [qrUrl, setQrUrl] = useState(null);
  const pollerRef = useRef(null);
  const qrRequestRef = useRef(0);
  const [isOverdue, setIsOverdue] = useState(false);
  const [imgLoading, setImgLoading] = useState(false);

  const stopPolling = () => {
    pollerRef.current?.stop();
    pollerRef.current = null;
  };

  //刷新二维码
  const refreshRQ = async () => {
    const requestId = qrRequestRef.current + 1;
    qrRequestRef.current = requestId;
    stopPolling();
    setIsOverdue(false);
    setImgLoading(true);
    try {
      const res = await getQrFunc();
      if (requestId !== qrRequestRef.current) return;
      if (res.data.code !== 0) {
        message.error(res.data.msg);
        return;
      }
      const data = getApiPayload(res);
      setQrUrl(data?.qrcode || "");
      const poller = createQrPoller({
        poll: (token) => Api.getTokenByPollToken(token),
        isComplete: (result) =>
          Boolean(result?.ticket || result?.token || result?.token_response || result?.status === "phone_binding_required"),
        onComplete: (result) => {
          if (result?.status === "phone_binding_required") {
            onPhoneBinding(data?.poll_token);
          } else {
            onFinish(result);
          }
        },
        onExpired: () => {
          stopPolling();
          setIsOverdue(true);
          message.error("二维码或登录凭证已过期，请刷新二维码");
        },
        onError: (msg, code) => {
          if (code !== WECHAT_QR_EXPIRED_CODE && msg) message.error(msg);
        },
      });
      pollerRef.current = poller;
      poller.start(data?.poll_token, data?.expires_in);
    } catch (_) {
      if (requestId === qrRequestRef.current) {
        message.error("二维码加载失败，请稍后重试");
      }
    } finally {
      if (requestId === qrRequestRef.current) setImgLoading(false);
    }
  };

  useEffect(() => {
    refreshRQ();
    return () => {
      qrRequestRef.current += 1;
      stopPolling();
    };
    // 二维码组件挂载时创建一次，卸载时统一停止轮询。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="qrForm">
      <div className="qrFormImg">
        {isOverdue && (
          <div className="overdueBox" onClick={refreshRQ}>
            <svg
              t="1701152961032"
              viewBox="0 0 1024 1024"
              version="1.1"
              p-id="5490"
              width="34"
              height="34"
            >
              <path
                d="M512 919.552c-224.768 0-407.552-182.784-407.552-407.552 0-8.704 0.512-17.408 1.024-26.112l71.68 4.608c-0.512 7.168-0.512 14.336-0.512 21.504 0 185.344 150.528 335.872 335.872 335.872 86.528 0 168.448-32.768 230.912-92.16l49.152 52.224C716.288 880.128 616.96 919.552 512 919.552zM919.552 512h-71.68c0-11.776-0.512-23.552-2.048-35.328-17.92-171.52-161.28-300.544-334.336-300.544-67.584 0-132.096 19.968-187.904 57.344L284.16 174.08c67.072-45.568 145.92-69.632 227.84-69.632 209.408 0 384 156.672 405.504 365.056 1.536 13.824 2.048 28.16 2.048 42.496z"
                p-id="5491"
              ></path>
              <path
                d="M140.288 290.816L28.16 491.52c-3.072 5.12 1.024 11.776 6.656 11.776H258.56c6.144 0 9.728-6.144 6.656-11.776L153.6 290.816c-3.072-5.632-10.752-5.632-13.312 0zM870.4 675.84L758.272 475.136c-3.072-5.12 1.024-11.776 6.656-11.776h223.744c6.144 0 9.728 6.144 6.656 11.776L883.712 675.84c-2.56 5.12-10.24 5.12-13.312 0zM270.336 202.24a35.84 35.84 0 1 0 71.68 0 35.84 35.84 0 1 0-71.68 0zM728.576 784.896a35.84 35.84 0 1 0 71.68 0 35.84 35.84 0 1 0-71.68 0z"
                p-id="5492"
              ></path>
            </svg>
          </div>
        )}
        {imgLoading ? (
          <div className="imgLoadingBox">
            <Spin size="large"></Spin>
          </div>
        ) : (
          <img src={qrUrl} alt="请扫描二维码" />
        )}
      </div>
      <div className="qrFormTip">
        {!isOverdue ? `请使用微信扫描二维码登录` : "二维码已失效，点击刷新"}
      </div>
    </div>
  );
};

const Metric = ({ icon, label }) => {
  return (
    <div className={styles.metricCard}>
      <div className={styles.metricIcon}>{icon}</div>
      <div className={styles.metricLabel}>{label}</div>
    </div>
  );
};

export default function AiSaasLogin() {
  const [formType, setFormType] = useState("account");
  const [bindingPollToken, setBindingPollToken] = useState("");
  const [qrGeneration, setQrGeneration] = useState(0);
  const [state, setState] = useUrlState({}, { navigateMode: 'replace' })

  //免登录轮询相关 ref
  const silentPollerRef = useRef(null)
  const silentPollingRef = useRef(false)

  //停止免登录轮询
  const stopSilentPolling = () => {
    silentPollingRef.current = false
    if (silentPollerRef.current) {
      clearTimeout(silentPollerRef.current)
      silentPollerRef.current = null
    }
  }

  //单次执行免登录判断：命中则跳转，未命中则由调用方决定是否继续轮询
  const runSilentLoginTick = async () => {
    silentPollerRef.current = null
    if (!silentPollingRef.current) return false

    try {
      //若已存在本应用 token，通过 redirectFunction 走 /loading 鉴权
      if (getToken()) {
        silentPollingRef.current = false
        window.location.href = state.redirect
        return true
      }
      //调静默登录接口查询免登录信息
      const res = await Api.silentLogin()
      if (!silentPollingRef.current) return false
      if (res?.data?.code === 0 && res?.data?.data?.ticket) {
        silentPollingRef.current = false
        //如果嵌在iframe中 则需要判断是否是跳到自动切换界面
        if(window !== window.top || window !== window.parent){
          if(sessionStorage.getItem('target_url') && sessionStorage.getItem('need_switch')){
            window.location.href = getLocationOrigin() + `/link?target=${sessionStorage.getItem('target_url')}` 
            return true
          }else{
            redirectFunction(res.data.data.ticket, state.redirect)
            return true
          }
        }else{
          redirectFunction(res.data.data.ticket, state.redirect)
          return true
        }
      }
    } catch (_) {
      //静默吞掉网络错误，继续下一轮
    }

    //未命中，继续下一轮
    if (silentPollingRef.current) {
      silentPollerRef.current = setTimeout(runSilentLoginTick, 3000)
    }
    return false
  }

  //启动免登录轮询：先立即调一次，命中后停止；未命中则每 3s 继续
  const startSilentPolling = () => {
    if (silentPollingRef.current) return //已在轮询中，避免重复启动
    stopSilentPolling()
    silentPollingRef.current = true
    runSilentLoginTick()
  }

  const handleSubmit = async (values) => {
    if (formType === "account") {
      //账号密码登录
      const res = await passwordLoginFunction(values);
      if (res.success) {
        redirectFunction(res.ticket, state.redirect);
      } else {
        message.error(res.msg);
      }
    } else if (formType === "captcha") {
      //手机号短信登录
      const res = await phoneLoginFunction(values);
      if (res.success) {
        redirectFunction(res.ticket, state.redirect);
      } else {
        message.error(res.msg);
      }
    } else if (formType === "qrcode") {
      //扫码登录
      if (values?.ticket) {
        redirectFunction(values.ticket, state.redirect);
      } else {
        const tokenResponse = values?.token_response || values;
        if (tokenResponse?.token) {
          setToken(tokenResponse.token);
          setSuperGroup(tokenResponse.super_group || false);
          redirectFunction(undefined, state.redirect);
        }
      }
    }
  };

  useEventListener("keydown", (ev) => {
    if (ev.code === "Enter") {
      handleSubmit();
    }
  });

  const onTabsChange = (type) => {
    setFormType(type);
  };

  //获取验证码
  const getCaptchaFunc = (phoneNumber, type) => {
    //todo 调取发送验证码的接口
    Api.getVerifyCode({
      phone: phoneNumber,
      type,
    });
  };

  //获取二维码
  const getQrFunc = () => {
    return Api.getQRCodeUrl("2", "BOT");
  };

  //获取对于产品的配置
  const getPrdConfig = (prd_code) => {
    Api.getPrdConfig(prd_code).then((res) => {
      if(res?.data?.code === 0){
        localStorage.setItem('prefix', res.data?.data?.prefix || '')
      }
      //拿到产品配置信息后立即发起一次免登录判断（命中即停，未命中再 3s 轮询）
      startSilentPolling()
    });
  }

   //根据域名获取产品编码
   const getPrdCodeFunc = (link) => {
    return Api.getPrdCode(link).then((res) => {
      return res?.data?.data
    })
  }

  useEffect(() => {
    getPrdCodeFunc(state.redirect || '').then(res=>{
      if(res?.prd_code){
        getPrdConfig(res?.prd_code)
        setState({...state, prdCode: res?.prd_code})
      }
    })

  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.grid}>
        {/* Left branded panel */}
        <section
          className={styles.leftPanel}
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className={styles.leftOverlay} />
          <div className={styles.leftContent}>
            {/* Logo */}
            <div className={styles.logoWrap}>
              <div className={styles.logoIcon}>
                <img src={logo} alt="" />
              </div>
              {/* <span className={styles.logoText}>金融Ai助手</span> */}
            </div>

            {/* Hero text */}
            <div className={styles.heroText}>
              <div className={styles.badge}>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-sparkles-icon lucide-sparkles"
                >
                  <path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                  <path d="M20 2v4" />
                  <path d="M22 4h-4" />
                  <circle cx="4" cy="20" r="2" />
                </svg>
                <span>金融垂类 AI 工作台</span>
              </div>
              <h1 className={styles.heroTitle}>
                面向投研、合规与客户经营的专业金融助手
              </h1>
              <p className={styles.heroDesc}>
                登录后进入对话工作台，使用报告生成、监管问询问答、MCP调用、自定义Skill等能力
              </p>
            </div>

            {/* Metrics */}
            <div className={styles.metrics}>
              <Metric
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-file-text-icon lucide-file-text"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                    <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                    <path d="M10 9H8" />
                    <path d="M16 13H8" />
                    <path d="M16 17H8" />
                  </svg>
                }
                label="投行拓客拜访报告"
              />
              <Metric
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-shield-check-icon lucide-shield-check"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                }
                label="监管问询报告及问答"
              />
              <Metric
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-chart-column-icon lucide-chart-column"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16" />
                    <path d="M18 17V9" />
                    <path d="M13 17V5" />
                    <path d="M8 17v-3" />
                  </svg>
                }
                label="MCP调用及自定义skill"
              />
            </div>
          </div>
        </section>

        {/* Right form panel */}
        <section className={styles.rightPanel}>
          <div className={styles.formCard}>
            <div className={styles.formHeader}>
              <div className={styles.formIcon}>
                <img src={logo2} alt="" srcset="" />
              </div>
              {/* <h2 className={styles.formTitle}>吾道</h2> */}
              <p className={styles.formSubtitle}>为你写金融报告、解监管问询</p>
            </div>

            <div className={styles.form}>
              <Tabs
                onChange={onTabsChange}
                activeKey={formType}
                centered
                className="aiLoginFormTabs"
              >
                {/* 密码登录 */}
                <Tabs.TabPane
                  tab={
                    <div style={{ width: "80px", textAlign: "center" }}>
                      密码登录
                    </div>
                  }
                  key="account"
                >
                  <PasswordFrom
                    onFinish={handleSubmit}
                    getCaptchaFunc={getCaptchaFunc}
                    resetPasswordFunction={resetPasswordFunction}
                  ></PasswordFrom>
                </Tabs.TabPane>
                <Tabs.TabPane
                  tab={
                    <div style={{ width: "80px", textAlign: "center" }}>
                      手机号登录
                    </div>
                  }
                  key="captcha"
                >
                  <PhoneForm
                    onFinish={handleSubmit}
                    getCaptchaFunc={getCaptchaFunc}
                  ></PhoneForm>
                </Tabs.TabPane>
                <Tabs.TabPane
                  tab={
                    <div style={{ width: "80px", textAlign: "center" }}>
                      扫码登录
                    </div>
                  }
                  key="qrcode"
                >
                  <QrFrom
                    key={qrGeneration}
                    onFinish={handleSubmit}
                    getQrFunc={getQrFunc}
                    onPhoneBinding={setBindingPollToken}
                  ></QrFrom>
                </Tabs.TabPane>
              </Tabs>
            </div>

            <div className={styles.footerLine}></div>

            <div className={styles.disclaimer}>
              登录即视为您已阅读并同意
              <a href="/legal-agreement/wd_tos.html" target="_blank">
                《服务协议》
              </a>
              和
              <a href="/legal-agreement/wd_privacy.html" target="_blank">
                《隐私协议》
              </a>
            </div>
          </div>
        </section>
      </div>
      <WechatPhoneBindModal
        visible={Boolean(bindingPollToken)}
        pollToken={bindingPollToken}
        onSuccess={(ticket) => redirectFunction(ticket, state.redirect)}
        onCancel={() => {
          setBindingPollToken("");
          setQrGeneration((generation) => generation + 1);
        }}
      />
    </div>
  );
}
